import DiagnosesPage from "./DiagnosesPage";

export default DiagnosesPage;